import React, { memo, ReactElement, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FileHistorySelectors } from 'reactApp/modules/fileHistory/fileHistory.selectors';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { RootState } from 'reactApp/store';
import { ROW_HEIGHT } from 'reactApp/ui/Datalist/DataList.constants';
import { sendFilesHistoryGa } from 'reactApp/ui/FileHistory/FileHistory.helpers';
import { IFileHistoryListProps } from 'reactApp/ui/FileHistory/FileHistory.types';
import { FileHistoryItem } from 'reactApp/ui/FileHistory/FileHistoryList/FileHistoryItem';
import { VirtualList } from 'reactApp/ui/VirtualList/VirtualList';
import { EDividerSize } from 'reactApp/ui/VirtualList/VirtualList.types';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './FileHistoryList.css';

const DIVIDER_HEIGHT = 40;

export const FileHistoryList = memo<IFileHistoryListProps>(({ itemId, onPaidInfo }): ReactElement => {
    const items = useSelector((state: RootState) => FileHistorySelectors.getIds(state, itemId));

    const rootRef = useRef<any>(null);

    const renderItem = (id: string) => <FileHistoryItem id={id} onPaidInfo={onPaidInfo} />;

    useEffect(() => {
        if (items.length) {
            // если нет версий то отправляем empty-list (тк в списке еще есть divider, то в проверке надо его учитывать)
            sendFilesHistoryGa('show', items.length === 2 ? 'empty-list' : 'list');
        }
    }, [items]);

    return (
        <div className={styles.root}>
            <VirtualList
                list={items}
                renderItem={renderItem}
                hasMoreToLoad={false}
                viewMode={EViewMode.list}
                /** Experiment tempexp_14728-next-line */
                // eslint-disable-next-line new-cap
                rowHeight={ROW_HEIGHT()}
                dividerHeight={DIVIDER_HEIGHT}
                dividerSize={EDividerSize.SMALL}
                isLoading={false}
                loadOnScroll={noopVoid}
                customScrollElement={rootRef.current}
            />
        </div>
    );
});

FileHistoryList.displayName = 'FileHistoryList';
